import { render, staticRenderFns } from "./PriceCardBig.vue?vue&type=template&id=60eabb6e"
import script from "./PriceCardBig.vue?vue&type=script&lang=js"
export * from "./PriceCardBig.vue?vue&type=script&lang=js"
import style0 from "./PriceCardBig.vue?vue&type=style&index=0&id=60eabb6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports